import { render } from "./WizardSteps.vue?vue&type=template&id=b7652230&scoped=true&bindings={\"isCompleted\":\"options\",\"isActive\":\"options\",\"currentRoute\":\"options\"}"
import script from "./WizardSteps.vue?vue&type=script&lang=js"
export * from "./WizardSteps.vue?vue&type=script&lang=js"

import "./WizardSteps.vue?vue&type=style&index=0&id=b7652230&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b7652230"

export default script